export const USER_SETTINGS_AFFIX = "user-settings";
export const USER_SETTINGS_BIN_TYPE_SELECT = `${USER_SETTINGS_AFFIX}-bin-type-select`;
export const USER_SETTINGS_QUANTILE_TYPE_SELECT = `${USER_SETTINGS_AFFIX}-quantile-type-select`;
export const USER_SETTINGS_NUMBER_OF_QUANTILES_INPUT = `${USER_SETTINGS_AFFIX}-number-of-quantiles-input`;
